<template>
    <tr :style="rowStyle">
        <td>
            <span v-if="edit">
                <b-form-input
                    type="text"
                    v-model="form.name"
                    placeholder="Nombre del punto"
                    class="border"
                    style=""
                >
                </b-form-input>
            </span>
            <span v-else :style="potentialClash ? 'background: #ee9f3a; color: black; padding: 4px;' : ''" :title="potentialClash ? 'Se trata potencialmente de un hotel a revisar los datos de ZT con los datos contenidos en la aplicación de buses': ''">
                {{item.name}}
            </span>
        </td>
        <td>
            {{item.remote_name}}
        </td>
        <td>
            <span v-if="edit">
                <v-select
                    :options="is_hotel_options"
                    :reduce="(option) => option.value"
                    label="label"
                    v-model="form.is_hotel"
                    style=""
                    class="border"
                >
                </v-select>
            </span>
            <span v-else>
                <i v-if="item.is_hotel" class="fa fa-check-circle mr-2 text-primary" aria-hidden="true" title="Sí"></i>
                <i v-else class="fa fa-times mr-2 text-warning" aria-hidden="true" title="No"></i>
            </span>
        </td>
        <td>
            <span v-if="edit">
                <v-select
                    :options="is_pickup_options"
                    :reduce="(option) => option.value"
                    label="label"
                    v-model="form.is_pickup"
                    style=""
                    class="border"
                >
                </v-select>
            </span>
            <span v-else>
                <i v-if="item.is_pickup" class="fa fa-check-circle mr-2 text-success" aria-hidden="true" title="Sí"></i>
                <i v-else class="fa fa-times-circle mr-2 text-danger" aria-hidden="true" title="No"></i>
            </span>
        </td>
        <td>
            <span v-if="edit">
                <v-select
                    :options="is_beggining_options"
                    :reduce="(option) => option.value"
                    label="label"
                    v-model="form.is_beggining"
                    style=""
                    class="border"
                >
                </v-select>
            </span>
            <span v-else>
                <i v-if="item.is_beggining" class="fa fa-check-circle mr-2 text-success" aria-hidden="true" title="Sí"></i>
                <i v-else class="fa fa-times-circle mr-2 text-danger" aria-hidden="true" title="No"></i>
            </span>
        </td>
        <!-- <td>
            <span v-if="edit">
                <v-select
                    :options="geopointsListAdmin.filter(entry => entry.is_pickup).sort((a,b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1: -1)"
                    :reduce="(option) => option.id"
                    @search="onSearchPickupPoint"
                    label="name"
                    v-model="form.pickup_point"
                    style=""
                    class="border"
                >
                </v-select>
            </span>
            <span v-else style="text-decoration: line-through;">
                {{item.pickup_point != null ? item.pickup_point.name : '-'}}
            </span>
        </td> -->
        <td>
            <span v-if="edit">
                <v-select
                    :options="subzones_list"
                    :reduce="(option) => option.id"
                    @search="onSearchSubzone"
                    label="name"
                    v-model="form.sub_zone"
                    style=""
                    class="border"
                >
                </v-select>
            </span>
            <span v-else>
                {{item.sub_zone != null ? item.sub_zone.name : '-'}}
            </span>
        </td>
        <td>
            <span v-if="edit">
                <b-form-input
                    type="text"
                    v-model="form.map"
                    placeholder="URL lcalización"
                    class="border w-75"
                    style=""
                >
                </b-form-input>
            </span>
            <span v-else>
                <i 
                    v-if="item.is_pickup && item.map == ''"
                    class="fa fa-times-circle text-danger" title="La parada no tiene mapa de localización"
                ></i>
                <i 
                    v-else-if="item.is_pickup && item.map != ''"
                    class="fa fa-check-circle text-success" title="La parada tiene mapa de localización"
                ></i>
                <i 
                    v-else-if="!item.is_pickup"
                    class="fa fa-info-circle text-info" title="El hotel no tiene mapa de localización"
                ></i>
            </span>
        </td>
        <td>
            <i 
                v-if="item.is_pickup && (item.qr_url !== '' && item.qr_url !== null )"
                class="fa fa-info-circle text-success"
                :title="'QR de parada establecido establecido: ' + item.qr_url"
            ></i>
            <i 
                v-else-if="item.is_pickup && ( item.qr_url == '' || item.qr_url == null )"
                class="fa fa-times-circle text-danger"
                title="QR de parada NO establecido"
            ></i>
            <span
                v-else-if="!item.is_pickup"
                title="QR de parada NO aplica (esto es un hotel)"
            >-</span>
        </td>
        <td>
            {{ item.sync_zt ? item.trekksoft_id : '-'}}
        </td>
        <td>
            <i v-if="item.sync_zt" class="fa fa-check-circle mr-2 text-success" aria-hidden="true" title="Sí"></i>
            <i v-else class="fa fa-times-circle mr-2 text-danger" aria-hidden="true" title="No"></i>
        </td>
        <td>
            <b-button
                class="border mr-1"
                size="sm"
                variant="light"
                @click="editRow"
                v-if="!edit"
            >
                <i class="text-center fa fa-wrench fa-fw"></i>
                Editar
            </b-button>
            <b-button
                class="border mr-1"
                size="sm"
                variant="light"
                @click="saveChanges"
                v-if="edit"
            >
                <i class="text-center fa fa-save fa-fw"></i>
                Guardar
            </b-button>
            <b-button
                class="border mr-1"
                size="sm"
                variant="light"
                @click="edit = !edit"
                v-if="edit"
            >
                <i class="text-center fa fa-save fa-fw"></i>
                Cancelar
            </b-button>
            <b-button
                v-if="!edit"
                class="border mr-1"
                size="sm"
                variant="light"
                @click="deleteGeoPoint"
            >
                <i class="text-center fa fa-times fa-fw"></i>
                Eliminar
            </b-button>
            <b-button
                v-if="!edit"
                class="border mr-1"
                size="sm"
                variant="light"
                @click="boundHotelToEdit"
            >
                <i class="text-center fa fa-car fa-fw"></i>
                Editar recogidas
            </b-button>
        </td> 

    </tr>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';

export default {
    props: {
        item: {
            type: Object,
            required: true,
        },
        selectedSuprazone: {
            required: false,
        }
    },
    data() {
        return {
            edit: false,
            form: {
                name: this.item != null ? this.item.name : '',
                map: this.item != null ? this.item.map : '',
                is_hotel: this.item != null ? this.item.is_hotel : false,
                is_pickup: this.item != null ? this.item.is_pickup : false,
                is_beggining: this.item != null ? this.item.is_beggining : false,
                //pickup_point: this.item != null && this.item.pickup_point != null ? this.item.pickup_point.id : null,
                sub_zone: this.item != null && this.item.sub_zone != null ? this.item.sub_zone.id : null,  
            },
            is_hotel_options: [
               {
                    label: 'Sí',
                    value: true,
                },
                {
                    label: 'No',
                    value: false,
                }
            ],
            is_pickup_options: [
                {
                    label: 'Sí',
                    value: true,
                },
                {
                    label: 'No',
                    value: false,
                }
            ],
            is_beggining_options: [
                {
                    label: 'Sí',
                    value: true,
                },
                {
                    label: 'No',
                    value: false,
                }
            ],
            subzones_list: []
        }
    },
    methods: {
        async editRow() {
            this.edit = true
            if ( this.item.sub_zone != null ) {
                const data = {
                    'suprazone_id': this.item.sub_zone.pickup_zone.supra_zone.id,
                }
                //await this.$store.dispatch("geopoints/getAllGeopointsBySuprazone", data)
                this.subzones_list = await this.$store.dispatch("subzones/getSubzonesBySuprazone", data)
            } else {
                this.subzones_list = await this.$store.dispatch("subzones/getSubzones")
            }
        },
        async boundHotelToEdit() {
            // load relation hotel - pickups
            //this.suprazone = this.suprazoneAdminCurrent(this.suprazone_id)
            if ( this.item.sub_zone != null ) {
                const suprazone_id = this.item.sub_zone.pickup_zone.supra_zone.id
                const input_data = {suprazone_id: suprazone_id}
                await this.$store.dispatch("hotelStopGroups/getHotelStopGroupsBySuprazone", input_data)
                // filter the hotel I'm selecting
                console.log('hotelStopGroups', this.hotelStopGroups, this.item.id)
                const hotel = this.hotelStopGroups.find( (entry) => entry.hotel.id == this.item.id)
                const data = {
                    hotel: hotel
                }
                console.log('boundHotelToEdit', hotel)
                await this.$store.dispatch("hotelStopGroups/storeHotelEdit", data)
                this.$bvModal.show('editRelationHotelPickup')
            }
            
        },
        async saveChanges() {
            this.edit = false
            // update data
            const updateData = {
                geopoint_id: this.item.id,
                payload: {
                    'id': this.item.id,
                    ...this.form
                }
            }
            await this.$store.dispatch("geopoints/updateGeopoint", updateData) 
            const data = {
                'suprazone_id': this.selectedSuprazone, // item.sub_zone.pickup_zone.supra_zone.id,
            }
            await this.$store.dispatch("geopoints/getAllGeopointsBySuprazone", data)
            
            await this.$store.dispatch("geopoints/getAllGeopointsWithoutAssignedZone")
            this.$notify({
                group: "foo",
                title: "Punto geográfico " + this.item.name + " editado",
                text: "Se ha editado la información del punto geográfico",
                type: "success",
            });
        },
        async deleteGeoPoint() {
            let data = {
                id: this.item.id
            }
            await this.$store.dispatch("geopoints/deleteGeoPoint", data)

            data = {
                'suprazone_id': this.selectedSuprazone,
            }
            await this.$store.dispatch("geopoints/getAllGeopointsBySuprazone", data)
            await this.$store.dispatch("geopoints/getAllGeopointsWithoutAssignedZone")

            this.$notify({
                group: "foo",
                title: "Punto geográfico " + this.item.name + " eliminado",
                text: "Se ha eliminado la información del punto geográfico",
                type: "success",
            });
        },
        onSearchPickupPoint() {
        },
        onSearchSubzone() {
        }
    },
    computed: {
        ...mapGetters(['geopointsListAdmin', 'isDataLoading', 'hotelStopGroups']),
        rowStyle() {
            if ( this.item.pickup_point == null ) {
                return {
                    //'background': '#d7151540'
                }
            }
        },
        potentialClash() {
            if ( this.item.name != this.item.remote_name && this.item.sync_zt && !this.item.is_pickup ) {
                return true
            }
            return false
        }
    }
}
</script>